import appConfig from '../../config/app';
import { getAuthHeaders } from '../fetchers/auth';

export const updateUserPermissions = async ({
  gymUid,
  userId,
  permissions,
}) => {
  const options = await getAuthHeaders();
  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/update_permissions`,
    {
      method: 'POST',
      headers: {
        ...options,
      },
      body: JSON.stringify({ user_id: userId, permissions }),
    }
  );
  if (!response.ok) {
    throw new Error('Failed to update permissions');
  }
  return await response.json();
};
